import React from 'react'

const Rewind = ({ onClick }) => (
  <svg
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 456.555 456.555"
    width="1.5em"
    height="1.5em"
  >
    <g>
      <path
        d="M440.358,456.555c-3.084,0-6.141-1.063-8.599-3.112l-257.82-214.85c-3.063-2.553-4.833-6.329-4.833-10.316   c0-3.986,1.769-7.763,4.833-10.316l257.82-214.85c3.993-3.336,9.568-4.049,14.292-1.846c4.717,2.21,7.732,6.952,7.732,12.162v429.7   c0,5.21-3.014,9.952-7.732,12.162C444.232,456.135,442.288,456.555,440.358,456.555z M203.509,228.277l223.417,186.182V42.094   L203.509,228.277z"
        fill="#FFFFFF"
      />
      <path
        d="M274.024,456.555c-3.084,0-6.141-1.063-8.599-3.112L7.605,238.592c-3.063-2.553-4.833-6.329-4.833-10.316   c0-3.986,1.769-7.763,4.833-10.316l257.82-214.85c3.993-3.336,9.564-4.049,14.292-1.846c4.717,2.21,7.732,6.952,7.732,12.162   v66.532c0,7.413-6.011,13.428-13.428,13.428c-7.417,0-13.428-6.015-13.428-13.428V42.094L37.175,228.277l223.417,186.182v-37.865   c0-7.413,6.011-13.428,13.428-13.428c7.417,0,13.428,6.015,13.428,13.428v66.532c0,5.21-3.014,9.952-7.732,12.162   C277.898,456.135,275.954,456.555,274.024,456.555z"
        fill="#FFFFFF"
      />
    </g>
  </svg>
)

export default Rewind